<template>
  <div>
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="setAccountVisible = true"
      >添加</el-button
    > -->
    <el-dialog
      :visible="accountVisible"
      title="查看个人信息"
      width="400px"
      @close="closeDialog"
    >
      <el-form :model="showAccountInfo" ref="form" label-width="80px">
        <el-form-item label="邮箱">
          {{ showAccountInfo.email || '--' }}
        </el-form-item>
        <el-form-item label="手机">
          {{ showAccountInfo.tel || '--' }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'updatedialog',

  data() {
    return {}
  },

  computed: {
    ...mapState('userOld', ['accountVisible', 'showAccountInfo']),
  },
  methods: {
    ...mapMutations('userOld', ['setAccountVisible']),

    closeDialog() {
      this.$refs.form.resetFields()

      this.setAccountVisible(false)
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep.el-select {
  .el-input__inner {
    width: 100px;
  }
}
</style>
